import { api } from "../Apis/interceptor";

export const saveMessage = function (
  cust_id,
  userDetails,
  opp_id,
  message,
  fileName
) {
  return api.post(
    "/api/v1/saveMessage/" +
      cust_id +
      "/" +
      userDetails.userid +
      "/" +
      userDetails.firstname +
      " " +
      userDetails.surname +
      "/" +
      opp_id,
    { message: message, fileName: fileName }
  );
};

export const getMessages = function (cust_id, opp_id) {
  return api.get("/api/v1/getMessages/" + cust_id + "/" + opp_id);
};

export const saveImage = function (image) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/saveImage?image=${image}`);
};

export const checkUnreadMessages = function (cust_id, userDetails, opp_id) {
  return api.get(
    "/api/v1/checkUnreadMessages/" +
      cust_id +
      "/" +
      userDetails.userid +
      "/" +
      opp_id
  );
};

export const updateUnreadMessages = function (cust_id, userDetails, opp_id) {
  return api.get(
    "/api/v1/updateUnreadMessages/" +
      cust_id +
      "/" +
      userDetails.userid +
      "/" +
      opp_id
  );
};
